import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "m-img-empty",
  computed: {
    ...walletVuex.mapState(["isMobile"])
  }
};